import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Breed } from '@models/Breed';
import { Observable } from 'rxjs';
import { AppEnvironment } from 'src/environments/AppEnvironment';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: `root` })
export class BreedService {
	constructor(private readonly http: HttpClient) { }

	getAllBreeds(): Observable<Breed[]> {
		const breedsJson: string = `https://epiassets.azureedge.net/assets
			${[AppEnvironment.DEV, AppEnvironment.RC, AppEnvironment.LOCAL].includes(environment.appEnvironment) ? '-dev' : ''}
			/breeds/breeds.json`;

		return this.http.get<Breed[]>(breedsJson);
	}
}
